import tw, { css } from 'twin.macro'

export const selectedStyles = css`
  ${tw`bg-white/100`}

  &::before {
    content: '';
    width: 50px;
    height: 50px;
    border-radius: 9999px;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-opacity: 0.4;
    position: absolute;
  }
`

export const hoverStyles = css`
  &:hover {
    div {
      ${tw`bg-white/100`}
    }
    p {
      ${tw`translate-x-3 opacity-100`}
    }
  }
`

export const activeStyles = css`
  &:active {
    & > div {
      ${selectedStyles}
    }
  }
`
